import Avatar from "@gx/dls/avatar/Avatar";
import FlexWrapper, { AlignItems } from "@gx/dls/containers/FlexWrapper";
import Bold from "@gx/dls/text/Bold";
import Text, { TextSize, TextVariant } from "@gx/dls/text/Text";
import Widget, { WidgetVariant } from "@gx/dls/widget/Widget";

interface EditSourceOverviewDetailsProps {
  createdByName: string;
  createdByAvatarUrl?: string | null;
  createdByAvatarHex?: string;
  createdAt: string;
  updatedAtRelative: string;
}

const EditSourceOverviewDetails = ({
  createdByName,
  createdByAvatarUrl,
  createdByAvatarHex,
  createdAt,
  updatedAtRelative,
}: EditSourceOverviewDetailsProps) => {
  return (
    <Widget variant={WidgetVariant.BASE} fillWidth noHover>
      <FlexWrapper alignItems={AlignItems.CENTER} gap={8}>
        <Avatar size={20} img={createdByAvatarUrl} hex={createdByAvatarHex} />
        <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY}>
          Created {createdAt} by {createdByName}.{" "}
          <Bold>Last updated {updatedAtRelative.toLowerCase()}</Bold>.
        </Text>
      </FlexWrapper>
    </Widget>
  );
};

export default EditSourceOverviewDetails;
